import {loadStripe, Stripe} from '@stripe/stripe-js';


// export const stripe = await loadStripe(import.meta.env.VITE_API_STRIPE_API);
export let stripe: Stripe; 

export async function initStripe(){
  stripe = await loadStripe(import.meta.env.VITE_API_STRIPE_API) as Stripe;
}
